import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=7e1cf836&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=7e1cf836&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports